// @flow
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import Bandeau from 'brastrap/common/bandeau/Bandeau';
import ButtonLink from 'brastrap/common/button-link/ButtonLink';
import EditorialBlock from 'brastrap/editorial/editorial-block/EditorialBlock';
import EditorialContainer from 'brastrap/editorial/editorial-container/EditorialContainer';
import type { JobsMoreInfoPage as Props } from './jobs-more-info-page.types';

const messages = defineMessages({
  vacancy: { id: 'jobs.vacancy', defaultMessage: 'Vacancy' },
  apply: { id: 'jobs.apply', defaultMessage: 'Apply Now' },
});

const JobsMoreInfoPage = (props: Props) => {
  const {
    intl: { formatMessage },
  } = props;

  const returnNav = {
    label: formatMessage(messages.vacancy),
    url: '../',
  };

  return (
    <div className="c-jobs-more-info-page">
      <Bandeau title={props.title} returnNav={returnNav} />

      <div className="c-page__main">
        <div className="l-grid l-grid--reverse">
          <div className="l-grid__unit l-grid__unit--content">
            {props.moreInfoContainers.length > 0 && (
              <EditorialContainer containers={props.moreInfoContainers} />
            )}
            {props.link && (
              <ButtonLink
                label={formatMessage(messages.apply)}
                url={props.link}
                target="_blank"
              />
            )}
          </div>
          <div className="l-grid__unit l-grid__unit--aside">
            {props.sidebars.map((item, index) => (
              <EditorialBlock key={index} content={item} />
            ))}
          </div>
        </div>
      </div>

      {props.containers.length > 0 && (
        <EditorialContainer containers={props.containers} />
      )}
    </div>
  );
};

JobsMoreInfoPage.defaultProps = {
  sidebars: [],
  containers: [],
  moreInfoContainers: [],
};

export default injectIntl(JobsMoreInfoPage);
